var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedln(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#0A66C2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.72266,
    y: 8.7207,
    width: 22.5556,
    height: 22.5556,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8573 29.8577H25.7086V23.3605C25.7086 21.8112 25.6809 19.8168 23.5509 19.8168C21.39 19.8168 21.0594 21.5048 21.0594 23.2477V29.8573H16.9108V16.4965H20.8935V18.3224H20.9493C21.3478 17.6408 21.9238 17.0802 22.6158 16.7001C23.3078 16.3201 24.0899 16.1348 24.8789 16.1641C29.0838 16.1641 29.8591 18.9299 29.8591 22.5282L29.8573 29.8577ZM12.2296 14.6702C10.8999 14.6704 9.82178 13.5927 9.82156 12.263C9.82134 10.9333 10.899 9.85521 12.2287 9.85499C13.5584 9.85466 14.6365 10.9324 14.6367 12.2621C14.6368 12.9006 14.3833 13.5131 13.9318 13.9647C13.4804 14.4163 12.8681 14.6701 12.2296 14.6702ZM14.304 29.8578H10.1509V16.4965H14.3039V29.8577L14.304 29.8578ZM31.9256 6.00204H8.0662C6.93855 5.98935 6.01378 6.89268 6 8.02033V31.9792C6.01334 33.1075 6.938 34.0117 8.06609 33.9998H31.9256C33.0561 34.0138 33.9844 33.1096 34 31.9792V8.01847C33.9839 6.88863 33.0555 5.98541 31.9256 6.00018",
    fill: "#0A66C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedln);
export default __webpack_public_path__ + "static/media/linkedln.08cee52bc8c9ba8b7d5db2b744be9751.svg";
export { ForwardRef as ReactComponent };